// extracted by mini-css-extract-plugin
module.exports =  {"tc-tile-header":"TileHeader-module__tc-tile-header___X6tVq"};